<div class="flex gap-1">
  <ui-badge>
    <span class="max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
      {{ locations()[0] | formatLocationName }}
    </span>
  </ui-badge>
  @if (locations().length > 1) {
    <ui-badge> +{{ locations().length - 1 }} </ui-badge>
  }
</div>
